import { getEmailCampaignDetails_api } from "api/campaignApi";
import CampaignDetailsHeader from "elements/CampaignDetailsHeader";
import CardSymphony from "elements/CardSymphony";
import PageSymphony from "elements/PageSymphony";
import Stat from "elements/Stat";
import TabsSymphony, { TabItem } from "elements/TabsSymphony";
import TabSymphony from "elements/TabSymphony";
import useScreen from "Hooks/useScreen";
import Colors from "modules/Colors";
import { CampaignStatus, CampaignType } from "modules/Const";
import Sty from "modules/Sty";
import { EmailCampaignDetailsData } from "modules/Types";
import { styx } from "modules/Utils";
import { CSSProperties, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";

const COMMUNICATION_TABS: TabItem[] = [
    {
        id: 'email',
        title: 'Email',
    },
    // {
    //     id: 'sms',
    //     title: 'SMS',
    // },
]

const COMMUNICATION_DATA_TABS: TabItem[] = [
    {
        id: 'sent',
        title: 'Sent',
    },
    // {
    //     id: 'opens',
    //     title: 'Opens',
    // },
    // {
    //     id: 'clicks',
    //     title: 'Clicked',
    // },
]

const EmailDetailsV2 = () => {
    const history = useHistory();
    const params = useParams<{ id?: string }>();
    const { mStyle, mobileView } = useScreen();

    const id = params.id
    const campaignId = Number(id);

    const [selectedCommunicationTab, setSelectedCommunicationTab] = useState<TabItem>(COMMUNICATION_TABS[0]);
    const [selectedCommunicationDataTab, setSelectedCommunicationDataTab] = useState<TabItem>(COMMUNICATION_DATA_TABS[0]);
    const [emailCampaignDetails, setEmailCampaignDetails] = useState<EmailCampaignDetailsData | null>({} as EmailCampaignDetailsData);

    const { campaign_metadata } = emailCampaignDetails || {};
    const { email_fanbase, campaign_type, status, content } = campaign_metadata || {};
    const {
        openingRate = 0,
        clicks = 0,
        openedBy = 0,
        sentTo = 0,
        openAverage = 0,
        sentList = [],
    } = email_fanbase || {};

    const { subject_line, html_content } = content || {};

    const getEmailCampaignDetails = async () => {
        try {
            const res = await getEmailCampaignDetails_api(campaignId);
            setEmailCampaignDetails(res as EmailCampaignDetailsData);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        getEmailCampaignDetails();
    }, []);

    const renderUserRow = (user: any) => {
        return (
            <div
                className="userTableHeader2"
                style={sty.userTableHeader}
            >
                <div
                    className="userRowItem"
                    style={sty.userRowItem}
                >
                    {user.email}
                </div>
                <div
                    className="userRowItem"
                    style={sty.userRowItem}
                >
                    {user.name}
                </div>
                <div
                    className="userRowItem"
                    style={sty.userRowItem}
                >
                    {user.city},
                    <br />
                    {user.state} ({user.country})
                </div>
            </div>
        )
    }

    const renderUserTable = () => {
        return (
            <div className="userTable" style={sty.userTable}>
                <div
                    className="userTableHeader"
                    style={styx(sty.userTableHeader, Sty.text16grey)}
                >
                    <div
                        className="userTableHeaderItem"
                        style={sty.userTableHeaderItem}
                    >
                        Email
                    </div>
                    <div
                        className="userTableHeaderItem"
                        style={sty.userTableHeaderItem}
                    >
                        Name
                    </div>
                    <div
                        className="userTableHeaderItem"
                        style={sty.userTableHeaderItem}
                    >
                        Location
                    </div>
                </div>
                {sentList.map((user) => renderUserRow(user))}
            </div>
        )
    }

    const renderOpenRateBar = () => {
        return (
            <div className="emailOpenRateBar" style={sty.emailOpenRateBar}>
                <div className="emailOpenRateBarItem" style={sty.emailOpenRateBarItem}>
                    <div
                        className="emailOpenRateBarItemProgress"
                        style={styx(
                            sty.emailOpenRateBarItemProgress,
                            { width: `${openingRate}%` }
                        )}
                    />
                </div>
            </div>
        )
    }

    const renderEmailTab = () => {
        return (
            <TabSymphony
                className="emailDetailsV2CardTab"
                visible={selectedCommunicationTab.id === 'email'}
                style={sty.emailDetailsV2CardTab}
            >
                <CardSymphony
                    className="emailDetailsV2CardTabHeader"
                    title="Overview"
                    subtitle="Let's see your email's performance"
                    size="small"
                    isNoPadding
                />

                {/* <div className="emailOpenRateContainer" style={sty.emailOpenRateContainer}>
                    <div className="emailOpenRateItem" style={sty.emailOpenRateItem}>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 4 }}>
                            <div style={{ fontSize: 72, fontWeight: 400, whiteSpace: 'nowrap' }}>{openingRate}</div><div style={{ ...Sty.text24grey, marginTop: 16 }}>%</div>
                        </div>
                        <div style={{ ...Sty.text18grey, marginTop: -16 }}>
                            Open rate
                        </div>
                    </div>
                    {renderOpenRateBar()}
                </div> */}

                <div
                    className="emailOpenRateStatsContainer"
                    style={sty.emailOpenRateStatsContainer}
                >
                    <Stat
                        className="emailOpenRateStat"
                        icon="email"
                        stats={[
                            {
                                title: 'Emails sent',
                                value: sentTo,
                                displayType: 'number',
                            },
                        ]}
                    />
                    <Stat
                        className="emailOpenRateStat"
                        icon="email"
                        stats={[
                            {
                                title: 'Emails opened',
                                value: openedBy,
                                displayType: 'number',
                            },
                        ]}
                    />
                    <Stat
                        className="emailOpenRateStat"
                        icon="click"
                        stats={[
                            {
                                title: 'Emails clicked',
                                value: clicks,
                                displayType: 'number',
                            },
                        ]}
                    />
                </div>
            </TabSymphony>
        )
    }

    const renderSmsTab = () => {
        return (
            <TabSymphony
                className="emailDetailsV2CardTab"
                visible={selectedCommunicationTab.id === 'sms'}
                style={sty.emailDetailsV2CardTab}
            >
                <CardSymphony
                    className="emailDetailsV2CardTabHeader"
                    title="Overview"
                    subtitle="Let's see your text message's performance"
                    size="small"
                    isNoPadding
                />
            </TabSymphony>
        )
    }

    const renderSentTab = () => {
        return (
            <TabSymphony
                className="emailDetailsV2CardTab"
                visible={selectedCommunicationDataTab.id === 'sent'}
                style={sty.emailDetailsV2CardTab}
            >
                <CardSymphony
                    className="emailDetailsV2CardTabHeader"
                    title="Fans who got the email"
                    size="small"
                    isNoPadding
                />
                {renderUserTable()}
            </TabSymphony>
        )
    }

    const renderOpensTab = () => {
        return (
            <TabSymphony
                className="emailDetailsV2CardTab"
                visible={selectedCommunicationDataTab.id === 'opens'}
                style={sty.emailDetailsV2CardTab}
            >
                <CardSymphony
                    className="emailDetailsV2CardTabHeader"
                    title="Fans who opened the email"
                    size="small"
                    isNoPadding
                />
            </TabSymphony>
        )
    }

    const renderClicksTab = () => {
        return (
            <TabSymphony
                className="emailDetailsV2CardTab"
                visible={selectedCommunicationDataTab.id === 'clicks'}
                style={sty.emailDetailsV2CardTab}
            >
                <CardSymphony
                    className="emailDetailsV2CardTabHeader"
                    title="Fans who clicked the email call to action"
                    size="small"
                    isNoPadding
                />
            </TabSymphony>
        )
    }

    const renderCommunicationLeftSide = () => {
        return (
            <div
                className="emailDetailsV2LeftSide"
                style={styx(
                    sty.emailDetailsV2LeftSide,
                    mobileView ? { gap: 8 } : { gap: 16 }
                )}
            >
                <CardSymphony className="emailDetailsV2Card">
                    <TabsSymphony
                        className="emailDetailsV2CardTabs"
                        tabs={COMMUNICATION_TABS}
                        selectedTab={selectedCommunicationTab}
                        onChange={(tab) => setSelectedCommunicationTab(tab as TabItem)}
                    />
                    {renderEmailTab()}
                    {renderSmsTab()}
                </CardSymphony>

                <CardSymphony className="emailDetailsV2Card">
                    <TabsSymphony
                        className="emailDetailsV2CardTabs"
                        tabs={COMMUNICATION_DATA_TABS}
                        selectedTab={selectedCommunicationDataTab}
                        onChange={(tab) => setSelectedCommunicationDataTab(tab as TabItem)}
                    />
                    {renderSentTab()}
                    {renderOpensTab()}
                    {renderClicksTab()}
                </CardSymphony>
            </div >
        )
    }

    const renderCommunicationRightSide = () => {
        return (
            <CardSymphony
                className="emailDetailsV2RightSideCard"
                style={sty.emailDetailsV2RightSideCard}
            >
                <CardSymphony
                    className="emailRightSideCardHeader"
                    title="Mail preview"
                    size="small"
                />

                <div className="emailRightSideCardContent" style={sty.emailRightSideCardContent}>
                    <CardSymphony className="subjectMessageContent">
                        {subject_line}
                    </CardSymphony>
                    <CardSymphony className="bodyMessageContent">
                        <div dangerouslySetInnerHTML={{ __html: html_content || '' }} />
                    </CardSymphony>
                </div>
            </CardSymphony>
        )
    }

    return (
        <>
            <CampaignDetailsHeader
                className="emailDetailsV2Header"
                style={sty.emailDetailsV2Header}
                icon="increaseMusicStreams"
                campaignName="Email Campaign"
                playbookType={campaign_type as CampaignType || ''}
                campaignStatus={status as CampaignStatus || ''}
                onBack={() => history.push('/fans?tab=Campaigns')}
            />
            <PageSymphony
                className="emailDetailsV2Component"
                style={mStyle(sty, 'emailDetailsV2Component')}
                isContent
            >
                <div
                    className="emailDetailsContentRow"
                    style={mStyle(sty, 'emailDetailsContentRow')}
                >
                    {renderCommunicationLeftSide()}
                    {renderCommunicationRightSide()}
                </div>
            </PageSymphony>
        </>
    )
}

const sty: Record<string, CSSProperties> = {
    emailDetailsV2Component: {
        display: 'flex',
        gap: 16,
        width: '100%',
        paddingTop: 86,
    },
    emailDetailsV2Component_mobile: {
        flexDirection: 'column',
        paddingTop: 101,
    },
    emailDetailsContentRow: {
        display: 'flex',
        flexDirection: 'row',
        gap: 16,
        width: '100%',
    },
    emailDetailsV2LeftSide: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        width: '100%',
        paddingTop: 24,
    },
    emailDetailsV2RightSideCard: {
        position: 'sticky',
        top: 86 + 24,
        width: 280,
        minHeight: 100,
        borderRadius: 8,
        flexShrink: 0,
        alignSelf: 'flex-start',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        overflow: 'hidden',
    },
    emailDetailsV2RightSideCard_mobile: {
        width: '100%',
    },
    emailDetailsV2CardTab: {
        paddingTop: 24,
    },

    emailOpenRateContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 16,
    },
    emailOpenRateItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        flexShrink: 0,
    },
    emailOpenRateBar: {
        display: 'flex',
        flexDirection: 'row',
        gap: 16,
        width: '100%',
        marginTop: 16,
    },
    emailOpenRateBarItem: {
        width: '100%',
        height: 26,
        borderRadius: 1000,
        backgroundColor: Colors.grey2,
    },
    emailOpenRateBarItemProgress: {
        width: '50%',
        height: '100%',
        borderRadius: 1000,
        backgroundColor: Colors.purple,
    },
    emailOpenRateStatsContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: 16,
        marginTop: 16,
    },

    userTable: {
        border: Sty.border,
        borderRadius: 8,
        marginTop: 16,
    },
    userTableHeader: {
        display: 'flex',
        flexDirection: 'row',
        padding: 16,
        borderBottom: Sty.border,
    },
    userTableHeaderItem: {
        flex: 1,
    },
    userRowItem: {
        flex: 1,
    },

    emailRightSideCardContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        backgroundColor: Colors.grey,
        padding: 16,
    }
}

export default EmailDetailsV2;